export const getMediaMatch = (sanitizedQuery: string) => {
  const mediaQuery = !!window?.matchMedia(sanitizedQuery)?.matches;
  return mediaQuery;
};
